const Background = () => {
  return (
    <section id="about" class="section">
      <div class="anchorref" id="3"></div>
      <div class="container">
        <h2 class="section-title">About Us</h2>
        <p>
          Midwest Packaging Partners was founded by Bart Ellison and Simeon
          Stearns, two individuals with a passion for logistics and packaging.
          Simeon has over 17 years of experience in the industry, while Bart is
          a successful entrepreneur with over 20 years of experience running two
          businesses and owning a patented product. Together, they saw a need
          for a more efficient and customer-centric approach to packaging
          services, and thus Midwest Packaging Partners was born. Their vision
          is to revolutionize the packaging industry by providing top-notch
          services and innovative solutions to their clients.
        </p>
        <img
          src="https://c3store.nyc3.digitaloceanspaces.com/mwpackaging/package1.png"
          alt=""
        />
      </div>
    </section>
  );
};

export default Background;
